import { c as _c } from "react/compiler-runtime";
import { DOCS__PERMISSIONS } from '@algoacademy/backend/modules/docs/permissions';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { algoliasearch } from 'algoliasearch';
import { Configure, InstantSearch } from 'react-instantsearch';
import { useAuth } from '@/app/_auth/useAuth';
import { ALGOLIA_INDEXES } from '@/app/baza/_helpers/globalVariables';
import { Dialog } from './_components/CustomDialog';
import { CustomSearchBox } from './_components/CustomSearchBox';
import AlgoliaLogo from './_svg/AlgoliaLogo';
export const searchClient = algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID! ?? '', process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY! ?? '');
type SearchDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  SearchResultComponent: React.FC;
};
export function SearchDialog(t0) {
  const $ = _c(12);
  const {
    isOpen,
    onClose,
    SearchResultComponent
  } = t0;
  const {
    user,
    status: authStatus
  } = useAuth();
  if (authStatus === "loading") {
    return null;
  }
  const t1 = user.hasPermissions([DOCS__PERMISSIONS.KNOWLEDGE_BASE.MANAGE.ASSIGNED]) ? ALGOLIA_INDEXES.ALL_COLLECTIONS_AND_ONLY_PUBLIC_ARTCILES : ALGOLIA_INDEXES.PUBLIC_COLLECTIONS_AND_ARTCILES;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Configure hitsPerPage={10} typoTolerance="false" restrictSearchableAttributes={["collection.name", "article.name"]} />;
    t3 = <CustomSearchBox />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== SearchResultComponent) {
    t4 = <SearchResultComponent />;
    $[2] = SearchResultComponent;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1 || $[5] !== t4) {
    t5 = <InstantSearch searchClient={searchClient} indexName={t1}>{t2}{t3}{t4}</InstantSearch>;
    $[4] = t1;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex justify-end"><Link href="https://www.algolia.com/developers/" target="_blank" className="flex items-center gap-2"><P2 className="text-contentTertiary">Search by</P2><AlgoliaLogo className="text-algoliaBlue dark:text-white" /></Link></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isOpen || $[9] !== onClose || $[10] !== t5) {
    t7 = <Dialog open={isOpen} onClose={onClose} className="max-w-3xl">{t5}{t6}</Dialog>;
    $[8] = isOpen;
    $[9] = onClose;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}